import { Container, Row, Col, Image } from 'react-bootstrap'

const HelpfulResources = () => (
    <>
    <div className="section-helpful-resources">
        <Container>
            <Row>
                <Col xl={6,{offset:6}} lg={6,{offset:6}} md={6}>
                    <p>We'll share links to helpful resources<br/>
                        <small>and more...</small></p>
                    <Image src="../images/7bs/bg-helpful-resources01.png" alt="helpful resources" className="img-fluid w-100 d-md-none d-block"/>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-helpful-resources {
                background: #f5f5f5
            }

            .section-helpful-resources .container {
                background: url(../images/7bs/bg-helpful-resources01.png) no-repeat center left;
                padding-top: 145px;
                padding-bottom: 145px;
            }

            .section-helpful-resources p {
                color: #de7621;
                font-size: 40px;
                line-height: 48px;
            }

            .section-helpful-resources small {
                color: #212529;
                line-height: 38px;
            }

            @media (max-width: 767.98px) {

                .section-helpful-resources .container {
                    background: none;
                    padding-top: 35px;
                    padding-bottom: 0;
                }

                .section-helpful-resources p {
                    font-size: 30px;
                    line-height: 38px;
                }

                .section-helpful-resources small {
                    line-height: 34px;
                }

            }

        `}</style>
    </>
);

export default HelpfulResources;